export default __webpack_public_path__ + "static/media/thumb3.b0813d5d.png";